import AxiosControl from '../../context/axios/AxiosControl'
const Axios = AxiosControl()

export const getReservationPublicByCourtAndDate = (court, date) => async (dispatch) => {
    dispatch({
        type: 'RESERVATION_LOADING'
    })
    try {
        const { data, status } = await Axios.get(`/api/reservation/public/getreservationpublicbycourtanddate?court=${court}&date=${date}`)
        if (status === 200) {
            dispatch({
                type: 'RESERVATION_GETALL_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'RESERVATION_NOT_LOADING'
        })
    }
}

export const rentCourt = (reservationData, force = null) => async (dispatch) => {
    dispatch({
        type: 'RESERVATION_LOADING'
    })
    try {
        const { data, status} = await Axios.post('/api/reservation/register', {reservationData, force}, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200 || status === 264) {
            dispatch({
                type: 'RESERVATION_ADD_SUCCESS',
                payload: data
            })
        }else{
            if(status === 201){
                dispatch({
                    type: 'RESERVATION_ADD_NOT_SUCCESS',
                    payload: data
                })
            }
        }
    } catch (error) {
        dispatch({
            type: 'RESERVATION_NOT_LOADING'
        })
    }
}

export const getReservationsByClubAndDate = (club, date) => async (dispatch) => {
    dispatch({
        type: 'RESERVATION_LOADING'
    })
    try {
        const { data, status } = await Axios.get(`/api/reservation/getreservationsbyclubanddate?club=${club}&date=${date}`)
        if (status === 200) {
            dispatch({
                type: 'RESERVATION_GETALL_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'RESERVATION_NOT_LOADING'
        })
    }
}

export const getReservationsCanceledByClub = (club) => async (dispatch) => {
    dispatch({
        type: 'RESERVATION_LOADING'
    })
    try {
        const { data, status } = await Axios.get(`/api/reservation/getreservationscanceledbyclub?club=${club}`)
        if (status === 200) {
            dispatch({
                type: 'RESERVATION_GETALL_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'RESERVATION_NOT_LOADING'
        })
    }
}

export const getReservationsByClient = (client) => async (dispatch) => {
    dispatch({
        type: 'RESERVATION_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/reservation/getreservationsbyclient/' + client, {
            headers: { auth: sessionStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'RESERVATION_GETALL_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'RESERVATION_NOT_LOADING'
        })
    }
}

export const cancelReservation = (reservationId, multiple = false) => async (dispatch) => {
    dispatch({
        type: 'RESERVATION_LOADING'
    })
    try {
        const { data, status } = await Axios.post('/api/reservation/cancelreservation/' + reservationId, {multiple}, {
            headers: { auth: sessionStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'RESERVATION_CANCEL_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'RESERVATION_NOT_LOADING'
        })
    }
}